export const ourValuesTranslation = {
  en: {
    "Our Values": "Our Values",
    "Add Value": "Add Value",
    "Edit Value": "Edit Value",
    Delete: "Delete",
    "Search by title": "Search by title...",
    Title: "Title",
    Icon: "Icon",
    Description: "Description",
    "Title (EN)": "Title (EN)",
    "Title (AR)": "Title (AR)",
    "Description (EN)": "Description (EN)",
    "Description (AR)": "Description (AR)",
    Status: "Status",
    Active: "Active",
    Inactive: "Inactive",
    "Are you sure you want to delete value '{{title}}'?":
      "Are you sure you want to delete value '{{title}}'?",
    "This action cannot be undone.": "This action cannot be undone.",
    Home: "Home",
    Settings: "Settings",
    Landing: "Landing",
    "Created At": "Created At",
    Actions: "Actions",
    "Update Value": "Update Value",
    "Add New Value": "Add New Value",
    Cancel: "Cancel",
  },
  ar: {
    "Our Values": "قيمنا",
    "Add Value": "إضافة قيمة",
    "Edit Value": "تعديل القيمة",
    Delete: "حذف",
    "Search by title": "البحث حسب العنوان...",
    Title: "العنوان",
    Icon: "الأيقونة",
    Description: "الوصف",
    "Title (EN)": "العنوان (EN)",
    "Title (AR)": "العنوان (AR)",
    "Description (EN)": "الوصف (EN)",
    "Description (AR)": "الوصف (AR)",
    Status: "الحالة",
    Active: "نشط",
    Inactive: "غير نشط",
    "Are you sure you want to delete value '{{title}}'?":
      "هل أنت متأكد أنك تريد حذف القيمة '{{title}}'؟",
    "This action cannot be undone.": "لا يمكن التراجع عن هذا الإجراء.",
    Home: "الصفحة الرئيسية",
    Settings: "الإعدادات",
    Landing: "الموقع التعريفي",
    "Created At": "تاريخ الإنشاء",
    Actions: "الإجراءات",
    "Update Value": "تحديث القيمة",
    "Add New Value": "إضافة قيمة جديدة",
    Cancel: "إلغاء",
  },
};
